module.exports = __webpack_public_path__ + "static/media/selling-logo.b56282cd.svg";